import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

/*
 * Item displaying information for the report table
 */
export default function ReportItem({
  item,
  isOdd,
  type,
  ticketMeta,
  isDiamond = false,
  isIbo = false,
  orderedHeaders = [],
  iboColumns = [],
}) {
  const ticketMap = Object.fromEntries(
    (item?.tickets || []).map((ticket) => [ticket.ticket, ticket])
  );

  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd, isIbo && styles.iboItemB)}>
      {isIbo ? (
        <>
          {/* IBO Columns Group */}
          <div
            className={classNames(
              styles.iboItemGroup,
              styles.iboColumnItemGroup
            )}
          >
            {iboColumns.map((col) => (
              <div
                key={col.key}
                className={classNames(
                  styles.iboExtra,
                  styles[`col_${col.key}`] // dynamically add class like .col_name, .col_pinLevel
                )}
              >
                {col.label === "Name"
                  ? `${item.firstName} ${item.lastName}`
                  : col.label === "Pin"
                  ? item.pinLevel
                  : item[col.label]}
              </div>
            ))}
          </div>

          {/* Dynamic Column Groups */}
          {orderedHeaders.map(({ header, columns }) => (
            <div
              key={header}
              className={classNames(
                styles.iboItemGroup,
                styles[`col_${header.replace(/\s+/g, "_")}`]
              )}
            >
              {columns.map((col) => {
                const match = (item.headers || []).find(
                  (h) =>
                    h.header === header &&
                    (h.column === col || h.columnName === col)
                );
                const value = match?.count ?? 0;
                return (
                  <div
                    key={`${header}-${col}`}
                    className={classNames(
                      styles.iboExtra,
                      match?.highlight === "yellow" && styles.highlightYellow,
                      match?.highlight === "green" && styles.highlightGreen
                    )}
                  >
                    {value}
                    {match?.isOverride && "*"}
                  </div>
                );
              })}
            </div>
          ))}
        </>
      ) : (
        <>
          <div className={styles.diamond}>
            {isDiamond ? item.diamond : item.eventName}
            {item.eventDate && ` - ${item.eventDate}`}
          </div>

          {ticketMeta.map(({ ticketName }) => {
            const ticket = ticketMap[ticketName];
            const value = ticket ? ticket.count || 0 : 0;

            return (
              <div key={ticketName} className={styles.extra}>
                {value}
              </div>
            );
          })}
          <div className={styles.extra}>
            {item?.tickets?.reduce(
              (sum, t) => sum + (t.isAttending ? t.count || 0 : 0),
              0
            )}
          </div>
        </>
      )}
    </div>
  );
}

ReportItem.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
  ticketMeta: PropTypes.array,
  isDiamond: PropTypes.bool,
};
